import { fetchUtils } from 'react-admin';
import d4backendProvider from '../d4backend_provider';


export const createDataProvider = apiUrl => auth => {
  const httpClient = (url, options = {}) => {
    const headers = new Headers({
      Accept: 'application/json',
      ...options.headers
    });

    if (auth.isAuthenticated && auth.user?.access_token) {
      headers.set('Authorization', `Bearer ${auth.user.access_token}`);
    }

    return fetchUtils.fetchJson(url, { ...options, headers });
  };

  return d4backendProvider(apiUrl, httpClient);
};
